module.exports = __webpack_public_path__ + "static/media/logo_img.04fb240e.svg";